import { render, staticRenderFns } from "./EditParticipant.vue?vue&type=template&id=08b5a455&"
import script from "./EditParticipant.vue?vue&type=script&lang=js&"
export * from "./EditParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports